import { Injectable } from '@angular/core';
import {
  PartnerReferralLinksResponse,
  PartnerReferralOverviewResponse,
} from '@interfaces/partners/responses/partner-referral.response';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

/**
 * Indique e ganhe (card 3461).
 *
 * Serviço à parte do `PartnersHttpService` (mesmo controller no backend) só para manter aquele
 * arquivo enxuto e não disputar o mesmo arquivo com outras frentes do card. O registro de clique
 * (`POST partners/referral/clicks`) e o cadastro com código são da landing, que chama a API
 * anonimamente — por isso não aparecem aqui.
 */
@Injectable({
  providedIn: 'root',
})
export class PartnerReferralsHttpService {
  private readonly BASE_URL = 'partners';

  constructor(private readonly apiService: VaultApiService) {}

  /**
   * O link de indicação do usuário logado (o código nasce na primeira chamada), os números e os
   * parceiros que chegaram por ele. Para o master, os números e a lista são do time inteiro.
   *
   * Não leva id de parceiro nem de usuário: o backend resolve pelo token.
   */
  getMyReferral(): Observable<PartnerReferralOverviewResponse | null> {
    return this.apiService.get<PartnerReferralOverviewResponse>(`${this.BASE_URL}/referral`);
  }

  /** Time interno: quem indicou este parceiro e quem ele indicou (Gerenciamento › Parceiros). */
  getPartnerReferrals(partnerId: string): Observable<PartnerReferralLinksResponse | null> {
    return this.apiService.get<PartnerReferralLinksResponse>(
      `${this.BASE_URL}/${partnerId}/referrals`
    );
  }
}
